import { render, staticRenderFns } from "./RegistrationStepFive.vue?vue&type=template&id=a2ead41a&scoped=true"
import script from "./RegistrationStepFive.vue?vue&type=script&lang=js"
export * from "./RegistrationStepFive.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStepFive.vue?vue&type=style&index=0&id=a2ead41a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ead41a",
  null
  
)

export default component.exports